import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'BCXValidatedInput',
  inheritAttrs: false,
};

import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { mdiEye, mdiEyeOff } from '@mdi/js';
import {
  computed, PropType, ref, WritableComputedRef
} from 'vue';
import { useVModel } from '@vueuse/core';
import BCXVuelidateErrors from '@/components/molecules/BCXVuelidateErrors.vue';
import EditIcon from '@/components/molecules/EditIcon.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String,
    default: ''
  },
  topLabel: {
    type: String,
    default: ''
  },
  hint: {
    type: String,
    default: ''
  },
  type: {
    type: String as PropType<'text' | 'password' | 'email'>,
    default: 'text'
  },
  maxLength: {
    type: Number as PropType<number | undefined>,
    default: undefined
  },
  vuelidateErrors: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  placeholder: {
    type: String,
    default: ''
  },
  hasHelpIcon: {
    type: Boolean
  }
},
  emits: ['keydown', 'blur', 'help'],
  setup(__props) {

const props = __props;





const vmInput = useVModel(props) as WritableComputedRef<string>;

const currentType = ref(props.type);
const charactersLeft = computed(() => (props?.maxLength ?? 0) - vmInput.value.length);

const togglePasswordVisibility = () => {
  currentType.value = currentType.value === 'password' ? 'text' : 'password';
};

return { __sfc: true,props, vmInput, currentType, charactersLeft, togglePasswordVisibility, BCXIcon, mdiEye, mdiEyeOff, BCXVuelidateErrors, EditIcon }
}

})